
    import { defineComponent, ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { useEquipmentStore } from '@/store/equipment'

    import SearchInputForm from './search-input-form.vue'

    import { buildLocalization, StringUtil } from '@/util'
    import { AxiosError, HttpStatusCode } from 'axios'

    export default defineComponent({
        name: 'SearchBySn',

        components: {
            SearchInputForm
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const equipmentStore = useEquipmentStore()
            const router = useRouter()
            const formRef = ref<InstanceType<typeof SearchInputForm> | null>(null)

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function handleLookupError(err: AxiosError) {
                formRef.value?.setError(
                    err.response?.status == HttpStatusCode.NotFound
                        ? localize('UnknownDevice')
                        : err.message
                )
            }

            function redirectToDevice(serialNo: string) {
                router.push({ name: 'equipment', params: { sn: serialNo } })
            }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function findDevice(serialNo: string) {
                equipmentStore.reset()

                if (StringUtil.isNullOrEmpty(serialNo)) {
                    formRef.value?.setError(localize('UnknownDevice'))
                    return
                }

                equipmentStore.setDevice(serialNo)
                    .then(response => redirectToDevice(response.data.serialNo))
                    .catch((err: AxiosError) => handleLookupError(err))
            }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return {
                formRef,
                localize,
                findDevice
            }
        }
    })
